module.exports = __webpack_public_path__ + "static/img/quxiaojingyin2.8793e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/quxiaojingyin2.png
// module id = M56/
// module chunks = 24